/**
 * 서버(ruda-api `S3ContentTypes.ofFilename`)가 presigned PUT URL 서명에 넣는 확장자별 Content-Type.
 * 여기에 없는 확장자는 서버가 `application/octet-stream` 으로 서명한다.
 */
const PRESIGNED_UPLOAD_CONTENT_TYPES: Record<string, string> = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  pdf: 'application/pdf',
};

const DEFAULT_UPLOAD_CONTENT_TYPE = 'application/octet-stream';

/**
 * 서버가 서명한 것과 같은 Content-Type 을 파일명 확장자로 정한다.
 * S3 는 서명된 Content-Type 과 실제 PUT 헤더가 다르면 403 으로 거절하는데,
 * 브라우저 `file.type` 은 HEIC·WebP 나 Windows 환경(빈 값, image/x-png 등)에서 서버와 어긋난다.
 */
export const getPresignedUploadContentType = (fileName: string): string => {
  const extension = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();
  return (
    PRESIGNED_UPLOAD_CONTENT_TYPES[extension] ?? DEFAULT_UPLOAD_CONTENT_TYPE
  );
};

/**
 * presigned URL로 파일을 S3에 업로드한다.
 * `contentType` 을 주면 그 값으로 보낸다(서버 서명과 맞춰야 하는 업로드). 없으면 브라우저 `file.type`.
 */
export const uploadFileToPresignedUrl = async (
  file: File,
  presignedUrl: string,
  contentType?: string,
): Promise<void> => {
  const response = await fetch(presignedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': contentType ?? (file.type || DEFAULT_UPLOAD_CONTENT_TYPE),
    },
  });
  if (!response.ok) {
    throw new Error('파일 업로드에 실패했습니다.');
  }
};
